import { inject } from "vue"

// Helper function to safely inject a store with fallback to empty object
export const safeInject = key => {
  try {
    return inject(key, {})
  } catch (e) {
    console.warn(`Store ${key} not available, using empty fallback`)
    return {}
  }
}
